import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {useStyles} from './DialogConfirmacaoStyles';
import PropTypes from 'prop-types';

function DialogConfirmacao(props) {
  const {
    mensagemBotaoEsquerda,
    mensagemBotaoDireita,
    acaoBotaoEsquerda,
    acaoBotaoDireita,
    mensagemPrincipal,
    tituloDialog,
    acaoAoFechar,
    open,
    componenteExtraDialogContent,
  } = props;
  const classes = useStyles;

  return (
    <Dialog
      open={open}
      onClose={acaoAoFechar}
      id={'dialog'}
    >
      <DialogTitle id={'tituloDialog'} >{tituloDialog}</DialogTitle>
      <DialogContent id={'dialogContent'}>
        {componenteExtraDialogContent ?
          componenteExtraDialogContent
          :
          <DialogContentText id={'mensagemPrincipalDialog'}>
            {mensagemPrincipal}
          </DialogContentText>
        }

      </DialogContent>
      <DialogActions>
        <Button
          onClick={e => acaoBotaoEsquerda(e)}
          color="primary"
          variant={'outlined'}
        >
          {mensagemBotaoEsquerda}
        </Button>
        <Button
          onClick={e => acaoBotaoDireita(e)}
          color="primary"
          variant={'contained'}
        >
          {mensagemBotaoDireita}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogConfirmacao.propTypes = {
  mensagemBotaoEsquerda: PropTypes.bool.isRequired,
  mensagemBotaoDireita: PropTypes.string.isRequired,
  acaoBotaoEsquerda: PropTypes.func.isRequired,
  acaoBotaoDireita: PropTypes.func.isRequired,
  mensagemPrincipal: PropTypes.string,
  tituloDialog: PropTypes.string,
  acaoAoFechar: PropTypes.func,
  open: PropTypes.bool.isRequired
};

export default DialogConfirmacao
